import React, { useState } from 'react';

const GeoWidget = ({ value, onChange, type = 'geopoint' }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const captureLocation = () => {
    setLoading(true);
    setError(null);
    if (!navigator.geolocation) {
      setError('Geolocation not supported');
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude, altitude, accuracy } = position.coords;
        const pointString = `${latitude} ${longitude} ${altitude || 0} ${accuracy}`;
        
        if (type === 'geopoint') {
          onChange(pointString);
        } else {
          const currentVal = value ? `${value}; ` : '';
          onChange(`${currentVal}${pointString}`);
        }
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
    );
  };

  const points = value ? value.split(';').filter(p => p.trim()) : [];

  return (
    <div className="p-4 border border-gray-200 rounded-[6px] bg-white space-y-3 shadow-sm">
      <div className="flex items-center justify-between">
         <span className="text-xs font-bold tracking-wider text-gray-500 uppercase">
           {type === 'geotrace' ? 'Location Trace' : 'Current Location'}
         </span>
         {points.length > 0 && <span className="text-xs font-medium text-blue-600 bg-blue-50 px-2 py-0.5 rounded-[4px]">{points.length} point(s)</span>}
      </div>
      
      {error && (
        <div className="flex items-center gap-2 text-red-600 text-xs bg-red-50 p-2 rounded-[6px] border border-red-100">
           <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
           {error}
        </div>
      )}

      <div className="space-y-2">
        {type === 'geopoint' ? (
           value ? (
             <div className="text-sm bg-gray-50 p-3 rounded-[6px] border border-gray-200 font-mono text-gray-700 break-all">
                <div className="mb-1 text-xs text-gray-400">Coordinates:</div>
                {value}
             </div>
           ) : <div className="py-2 text-sm italic text-gray-400">Location not captured yet.</div>
        ) : (
           <div className="pr-1 space-y-1 overflow-y-auto max-h-32 custom-scrollbar">
             {points.map((p, i) => (
                <div key={i} className="text-xs bg-gray-50 p-2 rounded-[6px] border border-gray-200 font-mono text-gray-700">
                  <span className="mr-2 font-bold text-gray-400">{i+1}.</span> {p}
                </div>
             ))}
             {points.length === 0 && <div className="py-2 text-sm italic text-gray-400">No points added.</div>}
           </div>
        )}
      </div>

      {!loading ? (
        <button 
          type="button" 
          onClick={captureLocation} 
          className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-[6px] h-10 font-medium transition-colors duration-200"
        >
          {type === 'geopoint' ? 'Record Location' : 'Add Point'}
        </button>
      ) : (
        <div className="flex items-center justify-center h-10 w-full bg-gray-100 rounded-[6px] text-blue-600 text-sm font-medium">
           <div className="w-4 h-4 mr-2 border-2 border-current rounded-full border-t-transparent animate-spin" />
           Fetching satellites...
        </div>
      )}
    </div>
  );
};

export default GeoWidget;
